var _path, _path2, _path3, _path4, _path5, _mask;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnotationPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 31V18C14 17.2044 14.3161 16.4413 14.8787 15.8787C15.4413 15.3161 16.2044 15 17 15H27C27.7956 15 28.5587 15.3161 29.1213 15.8787C29.6839 16.4413 30 17.2044 30 18V24C30 24.7956 29.6839 25.5587 29.1213 26.1213C28.5587 26.6839 27.7956 27 27 27H18L14 31Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 31C13.375 31.2528 13.5273 31.4807 13.7608 31.5774C13.9944 31.6742 14.2632 31.6207 14.4419 31.4419L18.2589 27.625H27C27.9614 27.625 28.8834 27.2431 29.5633 26.5633C30.2431 25.8834 30.625 24.9614 30.625 24V18C30.625 17.0386 30.2431 16.1166 29.5633 15.4367C28.8834 14.7569 27.9614 14.375 27 14.375H17C16.0386 14.375 15.1166 14.7569 14.4367 15.4367C13.7569 16.1166 13.375 17.0386 13.375 18V31Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21V21.0083",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21V21.0083",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21V21.0083",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-1_2529_18216",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1C7.22386 1 7 1.22386 7 1.5V7H1.5C1.22386 7 1 7.22386 1 7.5C1 7.77614 1.22386 8 1.5 8H7V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H8V1.5C8 1.22386 7.77614 1 7.5 1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationPointer);
export default __webpack_public_path__ + "static/media/annotation-pointer.0eb72cde5d454197e3663d22bc7484cd.svg";
export { ForwardRef as ReactComponent };